"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeavrSettlementTypesEnum = void 0;
var WeavrSettlementTypesEnum;
(function (WeavrSettlementTypesEnum) {
    WeavrSettlementTypesEnum["SALE_PURCHASE"] = "SALE_PURCHASE";
    WeavrSettlementTypesEnum["CASH_WITHDRAWAL"] = "CASH_WITHDRAWAL";
    WeavrSettlementTypesEnum["SALE_WITH_CASHBACK"] = "SALE_WITH_CASHBACK";
    WeavrSettlementTypesEnum["MAIL_OR_TELEPHONE_ORDER"] = "MAIL_OR_TELEPHONE_ORDER";
    WeavrSettlementTypesEnum["PURCHASE_REFUND_REVERSAL"] = "PURCHASE_REFUND_REVERSAL";
    WeavrSettlementTypesEnum["ORIGINAL_CREDIT_TRANSACTION_REVERSAL"] = "ORIGINAL_CREDIT_TRANSACTION_REVERSAL";
    WeavrSettlementTypesEnum["CASH_WITHDRAWAL_REVERSAL"] = "CASH_WITHDRAWAL_REVERSAL";
    WeavrSettlementTypesEnum["PURCHASE_REFUND"] = "PURCHASE_REFUND";
    WeavrSettlementTypesEnum["PURCHASE_REVERSAL"] = "PURCHASE_REVERSAL";
    WeavrSettlementTypesEnum["ORIGINAL_CREDIT_TRANSACTION"] = "ORIGINAL_CREDIT_TRANSACTION";
    WeavrSettlementTypesEnum["FIRST_CHARGEBACK"] = "FIRST_CHARGEBACK";
    WeavrSettlementTypesEnum["FIRST_CHARGEBACK_REVERSAL"] = "FIRST_CHARGEBACK_REVERSAL";
    WeavrSettlementTypesEnum["FIRST_REPRESENTMENT"] = "FIRST_REPRESENTMENT";
    WeavrSettlementTypesEnum["FIRST_REPRESENTMENT_REVERSAL"] = "FIRST_REPRESENTMENT_REVERSAL";
    WeavrSettlementTypesEnum["SECOND_CHARGEBACK"] = "SECOND_CHARGEBACK";
    WeavrSettlementTypesEnum["SECOND_CHARGEBACK_REVERSAL"] = "SECOND_CHARGEBACK_REVERSAL";
    WeavrSettlementTypesEnum["SECOND_REPRESENTMENT"] = "SECOND_REPRESENTMENT";
    WeavrSettlementTypesEnum["ARBITRATION_CHARGEBACK"] = "ARBITRATION_CHARGEBACK";
    WeavrSettlementTypesEnum["BALANCE_INQUIRY"] = "BALANCE_INQUIRY";
})(WeavrSettlementTypesEnum = exports.WeavrSettlementTypesEnum || (exports.WeavrSettlementTypesEnum = {}));
